import { DatePicker } from "antd"
import { Link } from "react-router-dom"
import Select from "react-select";
import { useDictionary } from "../../contexts/dictionary";
import { FormComponent } from "../../components/form";
import { FieldType, TextFieldType } from "../../components/fields";
import Joi from "joi";
import { DateTimePickerType } from "../../components/fields/DatePicker";
import { useContactType } from "../../contexts/ContactContext";
import { ActionButton } from "../../components/buttons/ActionButton";
import { useFormHandling } from "../../hooks/formUtils";
import { downloadFile, RequestConfigs } from "../../api";
import { DashboardPage } from "../../components/layout/dashboardPage";
import { useEffect, useState } from "react";

export const DashboardProfile: React.FC = () => {
  const { translate } = useDictionary()
  const { contact } = useContactType()

  const { handleFormClick, serverRes, handleInputChange } = useFormHandling({ requestType: RequestConfigs.updateContact })
  const contactId = contact?.id || ""
  const attachmentsForm = useFormHandling({ requestType: RequestConfigs.getContactAttachments, urlParams: { contactId: contactId } })
  console.log(contact, "acccc")
  const [attachments, setAttachments] = useState<any[]>([])

  useEffect(() => {
    if (attachmentsForm.serverRes?.succeeded && attachmentsForm.serverRes?.attachments) {

      const attachments = attachmentsForm.serverRes.attachments
      const mappedAttachments = attachments.map((attachment: Attachment) => ({
        name: attachment.File_Name,
        size: attachment.Size,
        url: `/contact/contacts/download/${attachment.id}`
      }))
      setAttachments(mappedAttachments)
      console.log(mappedAttachments, "attachments!")

    }
  }, [attachmentsForm.serverRes])

  useEffect(() => {
    attachmentsForm.handleClick()
  }, [])

  const formFields: FieldConfig[] = [
    {
      type: FieldType.text,
      name: "Full_Name",
      label: translate("name"),
      joiSchema: Joi.string().pattern(/^\s*\S+\s+\S+\s*$/).message('Must contain exactly two words').required(),
      defaultValue: contact?.First_Name,
      readonly: true,
      typeOptions: {
        type: TextFieldType.text,
      }
    },
    {
      type: FieldType.text,
      name: "Phone",
      label: translate("phone_label"),
      defaultValue: contact?.Phone,
      readonly: true,
      joiSchema: Joi.string().length(10).required(),
      typeOptions: {
        type: TextFieldType.text,
      }
    },
    {
      type: FieldType.text,
      name: "Email",
      label: translate("email_label"),
      defaultValue: contact?.Email,
      readonly: true,
      joiSchema: Joi.string().email({ tlds: { allow: false } }).required(),
      typeOptions: {
        type: TextFieldType.text,
      }
    },
    {
      type: FieldType.text,
      name: "payments0__Gov_Id",
      label: translate("id"),
      defaultValue: contact?.payments0__Gov_Id,
      joiSchema: Joi.string().required(),
      typeOptions: {
        type: TextFieldType.text,
      }
    },
    {
      type: FieldType.dateTime,
      name: "Date_of_Birth",
      label: translate("dob"),
      defaultValue: contact?.Date_of_Birth,
      joiSchema: Joi.string().required(),
      typeOptions: {
        dateType: DateTimePickerType.date,
      }
    },
    {
      type: FieldType.select,
      name: "Salutation",
      label: translate("gender"),
      defaultValue: contact?.Salutation,
      joiSchema: Joi.string().required(),
      typeOptions: {
        options: [
          {
            value: 'Mr.',
            label: translate('male')
          },
          {
            value: 'Mrs.',
            label: translate('female')
          },
          {
            value: 'Master.',
            label: translate('female')
          },
          {
            value: 'Miss.',
            label: translate('female')
          }
        ],
      }
    },
    {
      type: FieldType.upload,
      name: "upload",
      label: "upload",
      joiSchema: Joi.any(),
      defaultValue: attachments,
      typeOptions: {
        download: (url: string, fileName: string) => {
          downloadFile(url, fileName)
          console.log('download', url)
        }
      }
    },


  ]

  return (
    <DashboardPage title={translate('settings')}>
      <div className="col-lg-8 col-xl-9">
        <form >
          <>

            <div className="card">
              <div className="card-body">
                <div className="border-bottom pb-3 mb-3">
                  <h5>{translate('personal_info')}</h5>
                </div>



                <div className="setting-card">
                  <FormComponent
                    serverRes={serverRes}
                    fields={formFields}
                    onChange={handleInputChange}
                  />
                  <ActionButton width="100%" onClick={handleFormClick} label={translate('update')} />

                </div>



              </div>
            </div>
          </>

        </form>
      </div>
    </DashboardPage>

  )
}